import { render, staticRenderFns } from "./IAside.vue?vue&type=template&id=11cb8ad6&scoped=true&"
import script from "./IAside.vue?vue&type=script&lang=js&"
export * from "./IAside.vue?vue&type=script&lang=js&"
import style0 from "./IAside.vue?vue&type=style&index=0&id=11cb8ad6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11cb8ad6",
  null
  
)

export default component.exports